import React, { useEffect, useState } from 'react'
import './style.css'
import BasicDetails from './BasicDetails.jsx'
import IntroductionVideo from './IntroductionVideo.jsx'
import JobPreference from './JobPreference.jsx'
import Education from './Education.jsx'
import ProfileSummary from './ProfileSummary.jsx'
import ProfessionalExperience from './ProfessionalExperience.jsx'
import AdditionalInformation from './AdditionalInformation.jsx'
import { fetchNormalSubmission, getProfile, introVideoDetails } from '../../../Redux/Actions/ProfileSteps.js'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
const Steps = () => {
  const location = useLocation()
  const profileData = useSelector((s) => s.ProfileSteps.profileData)
  const resumeData = useSelector((s) => s.ProfileSteps.submissionData)
  const data = useSelector((s) => s.ProfileSteps.introData)
  const hasBasic = profileData?.user_name && resumeData?.submission?.length > 0
  const hasBasicVideo = data?.length > 0

  const redirectStep = location.state?.step < 3 ? (hasBasic ? location.state?.step : 1) : hasBasic && hasBasicVideo ? location.state?.step : hasBasic ? 2 : 1

  const [currentStep, setCurrentStep] = useState(redirectStep || 1)

  // const profileData = useSelector(state => state?.ProfileSteps?.profileData);
  const kids = useSelector((state) => state.dashboard.kids)

  const dispatch = useDispatch()
  useEffect(() => {
    kids && kids[0]?.id && dispatch(getProfile(kids[0]?.id))
    kids && kids[0]?.id && dispatch(fetchNormalSubmission({ kid_id: kids[0]?.id }))
    kids && kids[0]?.id && dispatch(introVideoDetails({ kid_id: kids[0]?.id }))
  }, [kids])

  const renderStepComponent = () => {
    switch (currentStep) {
      case 1:
        return <BasicDetails setCurrentStep={setCurrentStep} />
      case 2:
        return <IntroductionVideo setCurrentStep={setCurrentStep} />
      case 3:
        return <JobPreference setCurrentStep={setCurrentStep} />
      case 4:
        return <Education setCurrentStep={setCurrentStep} />
      case 5:
        return <ProfileSummary setCurrentStep={setCurrentStep} />
      case 6:
        return <ProfessionalExperience setCurrentStep={setCurrentStep} />
      case 7:
        return <AdditionalInformation setCurrentStep={setCurrentStep} />
      default:
        return <BasicDetails setCurrentStep={setCurrentStep} />
    }
  }

  const getStepClass = (stepNumber) => {
    if (stepNumber < currentStep) return 'passed'
    if (stepNumber === currentStep) return 'current'
    return ''
  }

  return (
    <>
      <div className="container-fluid">
        <div className="steps-main-sec">
          <ul className="steps my-3 my-md-5">
            <li className={getStepClass(1)}>
              <span className="steps-number">1</span>
              <div className="mt-1 mt-md-3">Basic Details</div>
            </li>
            <li className={getStepClass(2)}>
              <span className="steps-number">2</span>
              <div className="mt-1 mt-md-3">Introduction Video</div>
            </li>
            <li className={getStepClass(3)}>
              <span className="steps-number">3</span>
              <div className="mt-1 mt-md-3">Job Preference</div>
            </li>
            <li className={getStepClass(4)}>
              <span className="steps-number">4</span>
              <div className="mt-1 mt-md-3">Education </div>
            </li>
            <li className={getStepClass(5)}>
              <span className="steps-number">5</span>
              <div className="mt-1 mt-md-3">Profile Summary</div>
            </li>
            <li className={getStepClass(6)}>
              <span className="steps-number">6</span>
              <div className="mt-1 mt-md-3">Professional Experience</div>
            </li>
            <li className={getStepClass(7)}>
              <span className="steps-number">7</span>
              <div className="mt-1 mt-md-3">Additional information</div>
            </li>
          </ul>
        </div>
      </div>
      <div className="steps-main">{renderStepComponent()}</div>

      {/* Navigation buttons */}
      {/* <div className='d-flex justify-content-between mt-4'>
        <button 
          onClick={() => setCurrentStep(prev => prev - 1)} 
          disabled={currentStep === 1}
          className='btn btn-secondary'
        >
          Previous
        </button>
        <button 
          onClick={() => setCurrentStep(prev => prev + 1)} 
          disabled={currentStep === 7}
          className='btn btn-primary'
        >
          {currentStep === 7 ? 'Submit' : 'Next'}
        </button>
      </div> */}
    </>
  )
}

export default Steps
